import React from 'react';

const TrailerPage = () => {
    const videoSrc = `https://vv-cdn.s3.ap-south-1.amazonaws.com/sundaytraveller/videos/trailer-one.mp4`;

    return (
        <div
            className="container d-flex flex-column justify-content-center align-items-center"
            style={{ height: '100vh' }}
        >
            <div className="video-container" style={{ width: '80%', maxWidth: '700px' }}>
                <video className="w-100" controls>
                    <source src={videoSrc} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
            <div className="mt-3 text-center text-white">
                <p>
                    From <i><a href="http://www.walnutpublication.com/book/9798891711426/?utm_source=pages-app&utm_medium=qr-code&utm_campaign=sunday-traveller" target="_blank" rel="noopener noreferrer" className="text-white">Mayan Routes</a></i> by{' '}
                    <i><a href="https://www.thesundaytraveller.com/?utm_source=pages-app&utm_medium=qr-code&utm_campaign=sunday-traveller" target="_blank" rel="noopener noreferrer" className="text-white">Vineet Kumar</a></i>
                </p>
            </div>
        </div>
    );
};

export default TrailerPage;
